define("shared/modifiers/on-escape-key-down", ["exports", "ember-modifier", "shared/utils/handle-key-down", "shared/utils/constants/keys"], function (_exports, _emberModifier, _handleKeyDown, _keys) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-modifier",0,"shared/utils/handle-key-down",0,"shared/utils/constants/keys"eaimeta@70e063a35619d71f

  /**
   *
   * @class OnEscapeKeyDown
   * @extends Modifier
   *
   * OnEscapeKeyDown adds an event listener to the document, specifically listening for a keydown event with the 'escape' key.
   * When the escape key is pressed, whatever callback has been passed into the modifier will be called.
   *
   * Parameters:
   * @param {Function} callback The function to be called when the 'escape' key is pressed
   *
   * Usage:
   * Will close modal when escape key is pressed:
   * <div {{on-escape-key-down this.closeModal}} />
   *
   *
   */
  var _default = (0, _emberModifier.modifier)((_element, _ref) => {
    let [callback] = _ref;

    /**
     * Calls handleKeyDown with the event, 'escape' key, and callback
     *
     * @method keyHandler
     *
     * @param {KeyboardEvent} event The keyboard event
     *
     */
    const keyHandler = event => (0, _handleKeyDown.default)(event, _keys.default.ESCAPE, callback);

    document.addEventListener('keydown', keyHandler);
    return () => {
      document.removeEventListener('keydown', keyHandler);
    };
  });

  _exports.default = _default;
});